module.exports = __webpack_public_path__ + "img/iconExitLogin.c7d6bb14.svg";